var render, staticRenderFns
import script from "./MainFunc.vue?vue&type=script&lang=js"
export * from "./MainFunc.vue?vue&type=script&lang=js"
import style0 from "./MainFunc.vue?vue&type=style&index=0&id=1bdab286&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports